import { ReactNode } from 'react';
import { LevelTableCellProps } from 'redesign';

export const INITIAL_PAGE = 0;

export type DocumentStatus = 'Pending' | 'Accepted' | 'Signed';

export enum DocumentPartyType {
  HQ = 'HQ',
  WORKER = 'Worker',
  PLATFORM = 'Platform',
}

export type DocumentsColumnDefinition = {
  id: string;
  flexWorkerName: {
    name: string;
    hasNotification: boolean;
  };
  documentTypeCopy: string;
  documentNameCopy: string;
  createdAt: string;
  updatedAt: string;
  status: DocumentStatus;
  issuer: {
    id: string;
    type: DocumentPartyType;
  };
  actions: { documentId: string };
};

export type DocumentsCellProps<T extends keyof DocumentsColumnDefinition> = LevelTableCellProps<
  DocumentsColumnDefinition,
  DocumentsColumnDefinition[T],
  DocumentsTableDefinition
>;

export type DocumentsTableDefinition = {
  getRowActions: (documentId: string) => ReactNode[];
};

export const DOCUMENTS_INITIAL_VALUES = {
  documentId: {
    initialValue: undefined,
    type: 'string',
  },
} as const;

export type DocumentsParams = {
  documentId?: string;
};

export type SetDocumentParams = (params: Partial<DocumentsParams>) => void;
